<template>
  <div class="approval-detail">
    <div class="text-right">
      <a-button slot="extra" @click="goBack">返回</a-button>
    </div>

    <!-- 审批流程 -->
    <a-card title="审批流程" :loading="loading" class="card">
      <process :process-list="process" />
    </a-card>

    <!-- 基本信息 -->
    <base-info :base-info="baseInfo" :schema="baseInfoSchema" />

    <!-- 申请明细 -->
    <apply-view-edit-detail
      ref="applyDetailComp"
      v-if="isFirstStep"
      :type="type"
      :credit-info="creditInfo"
      :base-info="baseInfo"
      :limit-amount="limitAmount"
      :loan-amount="loanAmount"
      :special-amount="specialAmount"
      :attachments="attachments"
      :risk-evaluation="riskEvaluation"
      :has-risk-modal="true"
      :can-edit-risk-type="canEditRiskType"
      @getModalFromCC="getModalFromCC"
      @getSegmentFromCC="getSegmentFromCC"
      @getLinkFromCC="getLinkFromCC"
      @getRiskTypeFromChild="getRiskTypeFromChild"
    />
    <apply-view-detail
      ref="applyDetailComp"
      v-else
      :type="type"
      :credit-info="creditInfo"
      :base-info="baseInfo"
      :limit-amount="limitAmount"
      :loan-amount="loanAmount"
      :special-amount="specialAmount"
      :attachments="attachments"
      :risk-evaluation="riskEvaluation"
      :has-risk-modal="true"
      :can-edit-risk-type="canEditRiskType"
      @getModalFromCC="getModalFromCC"
      @getSegmentFromCC="getSegmentFromCC"
      @getLinkFromCC="getLinkFromCC"
      @getRiskTypeFromChild="getRiskTypeFromChild"
    />

    <!-- 上一级审批意见 -->
    <a-card
      title="上一级审批意见"
      :loading="loading"
      v-if="approvalList.length"
      class="card"
    >
      <approval-remark-list :approval-list="approvalList" />
    </a-card>

    <!-- 审批意见 -->
    <a-card title="审批意见" class="card" :loading="loading">
      <quill-editor :token="token" ref="quillEditor"></quill-editor>
    </a-card>

    <a-card title="附件" class="card" :loading="loading">
      <affix ref="affix" :maxSize="30"></affix>
    </a-card>

    <!-- 增加审批人 -->
    <a-card
      title="增加审批人"
      :loading="loading"
      v-if="status == APPROVAL_STATUS_VALUE_OBJ.INIT"
    >
      <multi-select-approval ref="multiSelectApproval" :list="approvePersons" />
    </a-card>

    <footer-tool-bar>
      <a-button
        type="primary"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.PASS)"
        :loading="loading || actionLoading || warnLoading"
      >
        审批通过
      </a-button>
      <a-button
        type="danger"
        class="margin-right-20"
        @click="handleSubmit(APPROVAL_ACTION_OBJ.REJECT)"
        :loading="loading || actionLoading || warnLoading"
      >
        审批不通过
      </a-button>
      <!-- TODO: 待测 -->
      <a-button
        type="primary"
        @click="showNextApprovalModal = true"
        :loading="loading || actionLoading || warnLoading"
        v-if="hasNext == 1"
      >
        更换下一阶段审批人
      </a-button>
    </footer-tool-bar>

    <!-- 下一环节审批人对话框 -->
    <next-approval-modal
      v-if="hasNext == 1"
      :visible="showNextApprovalModal"
      :action-loading="actionLoading"
      :next-approve-person="nextApprovePerson"
      :next-approve-persons="nextApprovePersons"
      @onSubmitModal="onSubmitNextApprovalModal"
      @onCloseModal="onCloseNextApprovalModal"
    />

    <!-- 跨级审批对话框 -->
    <cross-approve-modal
      :show-modal="showCrossModal"
      :action-loading="actionLoading"
      :cross-hint-msg="crossHintMsg"
      @onCrossSubmit="handleCrossSubmit"
      @onCloseCrossModal="handleCloseCrossModal"
    />
    <!-- 预警提示信息 -->
    <warn-approve-modal
      :show-modal="warnCrossModal"
      :action-loading="warnLoading"
      :cross-hint-msg="warningMessage"
      @onCrossSubmit="handleWarnCrossSubmit"
      @onCloseCrossModal="handleWarnCrossModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getApplyDetail } from '../api'
import { APPROVAL_STATUS_VALUE_OBJ } from '../const'
import { APPROVAL_ACTION_OBJ } from './const'
import { NEED_CROSS_APPROVAL, ERR_OK, WARN_CROSS_APPROVAL } from 'config/index'
import { BASE_INFO_SCHEMA, BASE_INFO_EXTRA_SCHEMA } from '../schema'
import { doApprove, getPeriodists, getLevelBoolean } from './api'
import Process from '../components/Process.vue'
import BaseInfo from '../components/BaseInfo.vue'
import ApplyViewEditDetail from '../components/ApplyDetail/ApplyViewEditDetail.vue'
import ApplyViewDetail from '../components/ApplyDetail/ApplyViewDetail.vue'
import ApprovalRemarkList from '../components/ApprovalRemarkList.vue'
import QuillEditor from '../components/QuillEditor.vue'
import Affix from '../components/Affix.vue'
import MultiSelectApproval from '../components/MultiSelectApproval.vue'
import CrossApproveModal from '../components/CrossApproveModal.vue'
import WarnApproveModal from '../components/WarnApproveModal.vue'
import FooterToolBar from 'components/FooterToolBar.vue'
import NextApprovalModal from '../components/NextApprovalModal.vue'
import numeral from 'numeral'

export default {
  name: 'approval-detail',
  data() {
    return {
      loading: false,
      id: '',
      type: '',
      status: '',
      process: [], // 审批流程
      baseInfo: null, // 基本信息
      creditInfo: null, // 申请明细
      limitAmount: null, // 信用限额表格
      loanAmount: null, // 正常|临时额度表格
      specialAmount: null, // 专项额度表格
      attachments: [], // 附件
      riskEvaluation: '', // 信用风险等级评估
      approvePersons: [], // 审批人列表
      hasNext: 0,
      nextApprovePerson: '',
      nextApprovePersons: [],
      APPROVAL_STATUS_VALUE_OBJ,
      APPROVAL_ACTION_OBJ,
      actionLoading: false, // 底部button的loading状态
      warnLoading: false,
      showNextApprovalModal: false,
      newNextApprovePerson: null,
      showCrossModal: false,
      warnCrossModal: false,
      crossHintMsg: '', // 跨级审批时后端返回的提示信息
      warningMessage: '', //预警提示时后端返回的提示信息
      confirmSkipRemark: '',
      confirmRiskRemark: '',
      modelId: '', //从子子级传过来信息
      segmentId: '',
      link: '',
      termList: [],
      periodBo: false,
      n: 0,
      permissionLevel: '',
      canEditRiskType: false, // 是否可以编辑审批类型
      modifiedRiskType: null, // 修改后的审批类型值
    }
  },
  created() {
    const { id } = this.$route.params
    const { type, status, sn } = this.$route.query
    id && this._getApplyDetail(id)
    this.id = id
    this.type = type
    this.status = status
    this.sn = sn
  },
  computed: {
    ...mapGetters('user', ['token']),
    // 详情信息schema
    baseInfoSchema() {
      const status = this.status
      if (
        status == APPROVAL_STATUS_VALUE_OBJ.INIT ||
        status == APPROVAL_STATUS_VALUE_OBJ.PADDING ||
        status == APPROVAL_STATUS_VALUE_OBJ.PASSED
      ) {
        return Object.assign({}, BASE_INFO_SCHEMA, BASE_INFO_EXTRA_SCHEMA)
      }
      return BASE_INFO_SCHEMA
    },
    isFirstStep() {
      if (this.baseInfo && this.baseInfo.step === 1) {
        return true
      }

      if ([1, 2, 3, 4, 5].includes(this.permissionLevel)) return true
      return false
    },
    approvalList() {
      const process = this.process
      const list = []
      process.forEach((item, index) => {
        if (index == 0) return
        if (item.approvePerson) {
          list.push({ id: item.id, ...item.approvePerson })
        }
      })
      return list
    },
  },
  methods: {
    resetAmount(num) {
      return numeral(num).format('0.00')
    },
    getPermissionLevelOfPendingProcess(data) {
      if (!data || !Array.isArray(data.process)) {
        this.$message.error('数据格式不正确')
        return null
      }

      const pendingProcess = data.process.find(item => item.status === 0)
      return pendingProcess ? pendingProcess.permissionLevel : null
    },
    async _getApplyDetail(id) {
      try {
        this.loading = true
        const { data } = await getApplyDetail(id)
        this.permissionLevel = this.getPermissionLevelOfPendingProcess(data)
        if (data.baseInfo.riskWarning !== '') {
          this.$warning({
            title: '提示',
            content: '重要提示：该申请客户存在风险信息',
          })
        }
        if (data) {
          for (let key in data) {
            this[key] = data[key]
          }
        }
        const minus =
          Number(this.resetAmount(this.baseInfo.totalCreditLimit)) -
          Number(this.baseInfo.groupTotalAmount)
        this.baseInfo.groupExposure = minus
        Object.assign(this.baseInfo, {
          groupExposure: minus,
          financeTarget: '查询',
          kpiTarget: '查询',
        })
        if (this.baseInfo.companyType === 1) {
          delete this.baseInfo.exposure
        } else {
          delete this.baseInfo.groupExposure
        }

        // 获取审批类型编辑权限
        this._getLevelBoolean()

        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    async _getLevelBoolean() {
      try {
        const { data } = await getLevelBoolean()
        this.canEditRiskType = data
      } catch (error) {
        console.error('获取审批类型编辑权限失败:', error)
        this.canEditRiskType = false
      }
    },

    handleApprovePersonChange(value) {
      this.nextApprovePersonForm.setFieldsValue({
        nextApprovePerson: value,
      })
    },

    onSubmitNextApprovalModal(newNextApprovePerson) {
      this.newNextApprovePerson = newNextApprovePerson
      this.handleSubmit(APPROVAL_ACTION_OBJ.PASS, false, true)
    },
    onCloseNextApprovalModal() {
      this.showNextApprovalModal = false
    },
    handleCrossSubmit(confirmSkipRemark) {
      this.confirmSkipRemark = confirmSkipRemark
      this.handleSubmit(APPROVAL_ACTION_OBJ.PASS, true, true)
    },
    handleWarnCrossSubmit(confirmRiskRemark) {
      this.confirmRiskRemark = this.warningMessage + confirmRiskRemark
      this.handleSubmit(APPROVAL_ACTION_OBJ.PASS, false, true)
    },
    handleCloseCrossModal() {
      this.showCrossModal = false
    },
    handleWarnCrossModal() {
      this.warnCrossModal = false
    },
    /**
     * ack: 1-通过，2-不通过
     * confirmSkipStatus: 跨级审批 1-跨级，其他-未跨级
     * changeNextApprovePerson: 是否为下一环节审批人
     */
    async handleSubmit(
      ack,
      confirmSkipStatus,
      confirmRiskStatus,
      changeNextApprovePerson,
    ) {
      console.log(
        ack,
        confirmSkipStatus,
        confirmRiskStatus,
        changeNextApprovePerson,
      )
      if (this.actionLoading && this.warnLoading) {
        return
      }
      if (ack == APPROVAL_ACTION_OBJ.REJECT) {
        this._doApprove({
          ack,
          bpmId: this.id,
          remark: this.$refs.quillEditor.getContent(),
          attachmentIds: this.$refs.affix.getAttachmentIds(),
          model: this.modelId,
          segmentId: this.segmentId,
          link: this.link,
        })
        return
      }
      const checkApplyDetail = this.$refs.applyDetailComp.validate()
      if (!checkApplyDetail) {
        return
      }
      //业务模式必填
      if (this.sn) {
        console.log('this.creditInfo.model---', this.creditInfo.model)
        if (!this.modelId && !this.creditInfo.model) {
          this.$notification.warning({
            message: '提示',
            description: '业务模式不能为空！',
          })
          return
        }
        console.log('this.creditInfo.segmentId---', this.creditInfo.segmentId)
        if (!this.segmentId && !this.creditInfo.segmentId) {
          this.$notification.warning({
            message: '提示',
            description: 'Segment不能为空！',
          })
          return
        }
        console.log('this.creditInfo.link---', this.creditInfo.link)
        if (!this.link && !this.creditInfo.link) {
          this.$notification.warning({
            message: '提示',
            description: '链路不能为空！',
          })
          return
        }
      }
      const checkApprovalPerson =
        this.status == APPROVAL_STATUS_VALUE_OBJ.INIT
          ? this.$refs.multiSelectApproval.validate()
          : {}
      if (!checkApprovalPerson) {
        return
      }
      try {
        await this.$refs.applyDetailComp.validateTotalAmount(confirmSkipStatus)
        const remark = this.$refs.quillEditor.getContent()
        const attachmentIds = this.$refs.affix.getAttachmentIds()
        const confirmSkipRemark = confirmSkipStatus
          ? this.confirmSkipRemark
          : ''
        const confirmRiskRemark = confirmRiskStatus
          ? this.confirmRiskRemark
          : ''

        const params = {
          bpmId: this.id,
          ack,
          confirmSkip: Number(confirmSkipStatus) || 0,
          confirmRisk: Number(confirmRiskStatus) || 0,
          confirmSkipRemark,
          confirmRiskRemark,
          remark,
          attachmentIds,
          ...checkApplyDetail,
          ...checkApprovalPerson,
          model: this.modelId,
          segmentId: this.segmentId,
          link: this.link,
        }

        // 如果用户修改了审批类型，添加到参数中
        if (this.modifiedRiskType !== null) {
          params.riskType = this.modifiedRiskType
        }
        console.log(params)
        // 若选择的是更换下一阶段审批人
        if (changeNextApprovePerson && this.newNextApprovePerson) {
          params.nextApprovePerson = this.newNextApprovePerson
        }
        if (
          params.limitAmount != undefined ||
          params.loanAmount != undefined ||
          params.specialAmount != undefined
        ) {
          this.periodTerm1(params)
        } else {
          this.periodTerm2()
        }
        //判断是否为标准账期
        const periodData = {
          termList: this.termList,
        }
        const { data } = await getPeriodists(periodData)
        this.periodBo = data.aboolean
        //为标准账期
        if (this.periodBo == true || this.n == 1) {
          this._doApprove(params)
        } else if (this.periodBo == false) {
          //非标准账期
          this.$confirm({
            title: '提示',
            content: '该账期非标准账期，是否继续?',
            okButtonProps: {
              loadings: this.loadings,
            },
            cancelText: '否',
            okText: '是',
            onOk: () => {
              this.loadings = true
              this._doApprove(params)
              this.n = 1
            },
          })
        }
      } catch (error) {
        console.error(error)
      }
    },

    periodTerm1(params) {
      if (params.limitAmount.term != undefined) {
        this.termList.push(params.limitAmount.term)
      }
      if (params.loanAmount.term != undefined) {
        this.termList.push(params.loanAmount.term)
      }
      if (params.specialAmount.length > 0) {
        for (let i = 0; i < params.specialAmount.length; i++) {
          this.termList.push(params.specialAmount[i].term)
        }
      }
    },

    periodTerm2() {
      if (this.limitAmount.term != undefined) {
        this.termList.push(this.limitAmount.term)
      }
      if (this.loanAmount.term != undefined) {
        this.termList.push(this.loanAmount.term)
      }
      if (this.specialAmount.length > 0) {
        for (let i = 0; i < this.specialAmount.length; i++) {
          this.termList.push(this.specialAmount[i].term)
        }
      }
    },

    async _doApprove(params) {
      this.actionLoading = true
      this.warnLoading = true
      try {
        const { code, message } = await doApprove(params)
        if (code == NEED_CROSS_APPROVAL) {
          // 需要跨级审批
          this.showCrossModal = true
          this.crossHintMsg = message
        } else if (code == ERR_OK) {
          this.$router.push({ name: 'audit-list' })
        } else if (code == WARN_CROSS_APPROVAL) {
          this.warnCrossModal = true
          this.warningMessage = message
          // 需要预警提示信息
        } else {
          this.$notification.warning({
            message: '提示',
            description: message,
          })
        }
        this.actionLoading = false
        this.warnLoading = false
      } catch (error) {
        console.error(error)
        this.$notification.error({
          message: '警告',
          duration: 0,
          description: error,
        })
      }
    },
    getModalFromCC(query) {
      this.modelId = query
    },
    getSegmentFromCC(query) {
      console.log('segmentId-----', query)
      this.segmentId = query
    },
    getLinkFromCC(query) {
      console.log('link-----', query)
      this.link = query
    },
    getRiskTypeFromChild(value) {
      console.log('riskType-----', value)
      this.modifiedRiskType = value
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  components: {
    Process,
    BaseInfo,
    ApplyViewEditDetail,
    ApplyViewDetail,
    ApprovalRemarkList,
    QuillEditor,
    Affix,
    MultiSelectApproval,
    CrossApproveModal,
    FooterToolBar,
    NextApprovalModal,
    WarnApproveModal,
  },
}
</script>

<style lang="less" scoped></style>
